import { ExposureData } from '@/models/FundLevel/Rebalancing/ExposureCapture';
import { ClassificationThresholds } from '@/models/FundLevel/Rebalancing/ClassificationThresholds';

import { ActionType, getType } from 'typesafe-actions';

import * as exposureCaptureAction from './actions';

type ExposureCaptureActionType = ActionType<typeof exposureCaptureAction>;

export type ExposureCaptureState = {
  exposureData: {
    data: ExposureData[];
    loading: boolean;
  };
  classTagLimits: {
    data: ClassificationThresholds[];
    loading: boolean;
  };
  apporveExposureLoading: boolean;
  updateExpoLimitLoading: boolean;
  uploadExposureDataLoading: boolean;
};

const initialState: ExposureCaptureState = {
  exposureData: {
    data: [],
    loading: false,
  },
  classTagLimits: {
    data: [],
    loading: false,
  },
  apporveExposureLoading: false,
  updateExpoLimitLoading: false,
  uploadExposureDataLoading: false,
};

export const exposureCaptureReducer = (
  state: ExposureCaptureState = initialState,
  action: ExposureCaptureActionType,
): ExposureCaptureState => {
  switch (action.type) {
    case getType(exposureCaptureAction.getExposureData.request):
      return {
        ...state,
        exposureData: {
          ...state.exposureData,
          loading: true,
        },
      };
    case getType(exposureCaptureAction.getExposureData.success):
      return {
        ...state,
        exposureData: {
          ...state.exposureData,
          data: action.payload.data,
          loading: false,
        },
      };
    case getType(exposureCaptureAction.getExposureData.failure):
      return {
        ...state,
        exposureData: {
          ...state.exposureData,
          loading: false,
        },
      };

    // class tag limit
    case getType(exposureCaptureAction.getExpoClassTagLimit.request):
      return {
        ...state,
        classTagLimits: {
          ...state.classTagLimits,
          loading: true,
        },
      };
    case getType(exposureCaptureAction.getExpoClassTagLimit.success):
      return {
        ...state,
        classTagLimits: {
          ...state.classTagLimits,
          data: action.payload.data,
          loading: false,
        },
      };
    case getType(exposureCaptureAction.getExpoClassTagLimit.failure):
      return {
        ...state,
        classTagLimits: {
          ...state.classTagLimits,
          loading: false,
        },
      };

    case getType(exposureCaptureAction.approveExposure.request):
      return {
        ...state,
        apporveExposureLoading: true,
      };
    case getType(exposureCaptureAction.approveExposure.success):
      return {
        ...state,
        apporveExposureLoading: false,
      };
    case getType(exposureCaptureAction.approveExposure.failure):
      return {
        ...state,
        apporveExposureLoading: false,
      };

    case getType(exposureCaptureAction.updateExpoClassLimit.request):
      return {
        ...state,
        updateExpoLimitLoading: true,
      };
    case getType(exposureCaptureAction.updateExpoClassLimit.success):
      return {
        ...state,
        updateExpoLimitLoading: false,
      };
    case getType(exposureCaptureAction.updateExpoClassLimit.failure):
      return {
        ...state,
        updateExpoLimitLoading: false,
      };

    case getType(exposureCaptureAction.uploadExposureFile.request):
      return {
        ...state,
        uploadExposureDataLoading: true,
      };
    case getType(exposureCaptureAction.uploadExposureFile.success):
      return {
        ...state,
        uploadExposureDataLoading: false,
      };
    case getType(exposureCaptureAction.uploadExposureFile.failure):
      return {
        ...state,
        uploadExposureDataLoading: false,
      };

    default:
      return state;
  }
};

export default exposureCaptureReducer;
